import { useState, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useUserContext } from "../../user-provider";
import { useUtilityContext } from "../../utility-provider";
import { apiRequest, postPython } from "../../api/ApiCall";
import { getLongPageData } from "../../data/DataManage";
import { 
    Box,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Grid,
    Table,
    TableContainer,
    TableBody,
    TableHead,
    TableRow,
    TableCell,
    Button,
    IconButton,
} from "@mui/material";
import dayjs from "dayjs";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import DownloadIcon from "@mui/icons-material/Download";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCover from "../subPage/AdditionalResearch/AddCover";
import AddDescriptionDocument from "../subPage/AdditionalResearch/AddDescriptionDocument";
import { LOCAL_CONSTANT } from "../Const";
import { staffName, commonFileDownload } from "../Common";
import PdfViewer from "../../utility/PdfViewer";
import PdfViewerModal from "../../utility/PdfViewerModal";
import { handlePdfPreviewScreenOpen } from "../../utility/PdfViewerModal";
import { setPermissionFunc, groupSearchFunc } from "../components/PermissionFunc";
import MessageDialog from "../components/MessageDialog";
import CriticalActionConfirmDialog from "../components/CriticalActionConfirmDialog";
import { addSurveyData } from "../components/LocationAddSurveyFunc";
import { upsertLocationAddSurvey } from "../components/LocationAddSurveyFunc";
import { locationBaseData } from "../components/LocationBaseFunc";
import { initCommentData } from "../subPage/DeficiencyComment/DeficiencyCommentFunction";
import { setAddSurveyObj } from "../../features/locationAddSurveySlice";
import { setAdditionalResearchMergePdf } from "../../features/additionalResearchSlice";
import { setDeficiencyComment } from "../../features/deficiencyCommentSlice";
import { setLocationBase, setRrBranchLog } from "../../features/longPageSlice";
import { DeleteConfirmationModal } from "../ResearchReport/DeleteConfirmationModal";

const headerCell = (type: string) => {
    return{
        backgroundColor: "#D9D9D9",
        fontSize: "12px",
        color: "black",
        borderBottom: "1px solid black",
        fontWeight: "Bold",
        width: type === "FILE_NAME" ? "40%"
        : type === "UPLOAD_DATE" ? "15%" 
        : type === "UPLOADER" ? "15%"
        : "6%",
        textAlign: type === "OTHER" ? "center" : "start"
    }
};

interface AdditionalResearchProps {
    props: {};
}

const AdditionalResearch: React.FC<AdditionalResearchProps> = ({ props }) => {

    const user = useUserContext();
    const dispatch = useAppDispatch();
    const utilityCtx = useUtilityContext();
    const objLocationBase = useAppSelector((state) => state.longPage.locationBase);
    const objLocationAddSurvey = useAppSelector((state) => state.locationAddSurvey.obj);
    const [mergePdfPath, setMergePdfPath] = useState<any[]>([]);
    const [userType, setUserType] = useState<string>("");
    const [accordionDefaultFlag, setAccordionDefaultFlag] = useState<boolean>(false);
    const [addSurveyTaskButton, setAddSurveyTaskButton] = useState<boolean>(true);
    const [taskChangeButtonType, setTaskChangeButtonType] = useState<string>("");
    //メッセージモーダル用ステート
    const [message, setMessage] = useState<string>("");
    const [messageDialogOpen, setMessageDialogOpen] = useState<boolean>(false);
    const [hasButton, setHasButton] = useState<boolean>(false);
    //PDFプレビュー
    const previewPdfPath = useAppSelector((state) => state.additionalResearch.mergePdfPath);
    //モーダル開閉フラグ(PDFプレビュー)
    const [pdfPreviewModalFlag, setPdfPreviewModalFlag] = useState(false);
    const [pdfPath, setPdfPath] = useState<string>("");
    //モーダル開閉フラグ(削除確認)
    const [deleteConfModalOpen, setDeleteConfModalOpen] = useState(false);
    //削除対象ファイル
    const [deleteTargetFile, setDeleteTargetFile] = useState<any>(null);
    //タスク変更モーダル用ステート
    const [taskChangeMessage, setTaskChangeMessage] = useState<string>("");
    const [taskChangeMessageDialogOpen, setTaskChangeMessageDialogOpen] = useState<boolean>(false);
    const [taskChangeMode, setTaskChangeMode] = useState<string>("");

    //結合ファイル情報取得
    useEffect(() => {
        if (objLocationAddSurvey.merge_file_path) {
            const parsedPath = typeof objLocationAddSurvey.merge_file_path === "string"
                ? JSON.parse(objLocationAddSurvey.merge_file_path)
                : objLocationAddSurvey.merge_file_path;
            setMergePdfPath(parsedPath);
            if (parsedPath.length > 0) {
                setAccordionDefaultFlag(true);
            }
            // タイムスタンプで降順ソート（新しい順）
            const sortedFiles = [...objLocationAddSurvey.merge_file_path].sort((a, b) => 
                new Date(b.upload_date).getTime() - new Date(a.upload_date).getTime()
            );
            setMergePdfPath(sortedFiles);
        }
        if (objLocationAddSurvey.merge_file_path.length > 0) {
            setAccordionDefaultFlag(true);
        }
    },[objLocationAddSurvey.merge_file_path]);

    //追加調査タスク変更ボタン活性、非活性設定
    useEffect(() => {
        let branch = 0;
        let taskGroup = "";
        if(String(objLocationBase.branch).trim() !== "") {
            branch = Number(objLocationBase.branch);
        }
        if(objLocationBase.task_id !== "") {
            taskGroup = groupSearchFunc(objLocationBase.task_id);
            setTaskChangeButtonType(taskGroup);
        }
        // ブランチが2以上かつ、タスクグループがAの場合ボタン活性
        if(branch >= 2 && taskGroup === "A") {
            setAddSurveyTaskButton(false);
        }
    },[objLocationBase]);

    //ユーザー情報取得
    useEffect(() => {
        if (JSON.parse(user.userData || "null") !== null) {
            setUserType(JSON.parse(user.userData || "null").user_type);
        }
    }, [user]);

    //日付表示用関数
    const showUploadDate = (param: any) => {
        let date = ""
        if (param) {
            date = dayjs(param).format("YYYY/MM/DD HH:mm:ss")
        }
        return date
    };

    //結合ファイル作成
    const handleCreateMergeFile = () => {
        const userData = JSON.parse(user.userData);
        const now = new Date();
        // タイムスタンプをゼロパディング 2025/12/9 13:5:27 ⇒ 2025/12/09 13:05:27
        const upload_date = `${now.getFullYear()}/${String(now.getMonth()+1).padStart(2, "0")}/${String(now.getDate()).padStart(2, "0")} ${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}:${String(now.getSeconds()).padStart(2, "0")}`;
        const javaParam = upsertLocationAddSurvey(
            objLocationAddSurvey, 
            objLocationBase.plan_area_id, 
            objLocationBase.branch
        );
        const pythonParams = {
            mode: "regist",
            endPoint: "/excel-add-print-pdf",
            query: {
                mode: "create_merge_pdf",
                plan_area_id: objLocationBase.plan_area_id,
                branch: objLocationBase.branch,
                upload_date: upload_date,
                user_data: {
                    update_top_department: userData.top_department_code_OA,
                    update_department: userData.department_code_OA,
                    update_job: userData.job_category_code_OA,
                    update_mail: userData.email.toString(),
                    update_stuff_number: userData.staff_number,
                    update_name: staffName(userData.staff_number)
                }
            }
        };
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        (async () => {
            try {
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.CREATE_PDF);
                setMessageDialogOpen(true);
                await apiRequest(javaParam);
                await postPython(pythonParams);
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.COMPLETE_CREATE_PDF);
                setHasButton(true);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            } catch (e) {
                console.log(e);
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.UNCOMPLETE_CREATE_PDF);
                setHasButton(true);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            }
        })();
    };

    //削除確認モーダル表示
    const handleDeleteConfModalOpen = (targetFile: any) => {
        setDeleteTargetFile(targetFile?.file_name);
        setDeleteConfModalOpen(true);
    };

    //削除確認モーダル(OK押下時処理)
    const handleDeleteChange = () => {
        handlePreviewChange("");
        deleteMergeFile();
    };

    //ファイル削除処理
    const deleteMergeFile = () => {
        const userData = JSON.parse(user.userData)
        const params = {
            mode: "regist",
            endPoint: "/excel-add-print-pdf",
            query: {
                mode: "delete_merge_pdf",
                plan_area_id: objLocationBase.plan_area_id,
                branch: objLocationBase.branch,
                target_file_name: deleteTargetFile,
                user_data: {
                    update_top_department: userData.top_department_code_OA,
                    update_department: userData.department_code_OA,
                    update_job: userData.job_category_code_OA,
                    update_mail: userData.email.toString(),
                    update_stuff_number: userData.staff_number,
                    update_name: staffName(userData.staff_number)
                }
            }
        };
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        (async () => {
            try {
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.DELETE_PDF);
                setMessageDialogOpen(true);
                // Python側でファイル削除とDB更新を実行
                await postPython(params);
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.SUCCESS_DELETE_PDF);
                setHasButton(true);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            } catch (e) {
                console.log(e);
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.ERROR_DELETE_PDF);
                setHasButton(true);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            }
        })();
    };

    //画面更新
    const loadApi = async () => {
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        //変更履歴取得
        callChangeHistory();
        callApi()
            .then((res: any) => {
                //追加調査
                dispatch(
                    setAddSurveyObj(addSurveyData(res.getLocationAddSurvey))
                );
                //基本情報
                dispatch(
                    setLocationBase(locationBaseData(res.getLocationBase))
                );
                //不備コメント
                dispatch(
                    setDeficiencyComment(
                        initCommentData(
                            res.getDeficiencyComment
                        )
                    )
                )
            })
            .catch((e) => {
                console.log(e);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            })
            .finally(() => {
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            });
    };

    const callApi = async () => {
        const param: any = [];
        param.push({
            mode: "getLocationAddSurvey",
            plan_area_id: objLocationBase.plan_area_id,
            branch: objLocationBase.branch,
        });
        param.push({
            mode: "getLocationBase",
            plan_area_id: objLocationBase.plan_area_id,
            branch: objLocationBase.branch,
        });
        param.push({
            mode: "getDeficiencyComment",
            plan_area_id: objLocationBase.plan_area_id,
            branch: objLocationBase.branch,
        });
        return await getLongPageData(param);
    };

    //変更履歴取得
    const callChangeHistory = () => {
        const params = {
            mode: "regist",
            endPoint: "/location/system/v1/get-log",
            query: {
                plan_area_id: objLocationBase.plan_area_id,
                branch: objLocationBase.branch,
                log_type: "rr-branch",
            },
        };
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        (async () => {
            try {
                const res = await apiRequest(params);
                // テーブル毎に集約
                let obj = res.data.reduce((acc: any, cur: any) => {
                    if (!acc[cur.target_table]) {
                        acc[cur.target_table] = [];
                    }
                    acc[cur.target_table].push(cur);
                    return acc;
                }, {});
                dispatch(setRrBranchLog(obj));
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            } catch (e) {
                console.log(e);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            }
        })();
    };

    // メッセージ用モダールクローズ処理
    const closeMessageDialog = () => {
        setMessage("");
        setHasButton(false);
        loadApi();
        setMessageDialogOpen(false);
    };

    //PDFプレビューを表示
    const handlePreviewChange = (pdfPath: string) => {
        const path = "gs://"
            + process.env.REACT_APP_FIREBASE_STORAGE_BUCKET
            + `/${objLocationBase.plan_area_id}/${objLocationBase.branch}${pdfPath}`
        //表示中のPDFレコードを押下時非表示
        if (previewPdfPath === path || pdfPath === "") {
            dispatch(setAdditionalResearchMergePdf(""));
        } else {
            dispatch(setAdditionalResearchMergePdf(path));
        }
    };

    //PDFプレビューモーダルオープン
    const handlePdfPreviewModalOpen = (pdfPathParam: string) => {
        setPdfPreviewModalFlag(true);
        setPdfPath(pdfPathParam);
    };

    //「追加調査を行う」ボタン押下時
    const handleChangeTaskAddSurvey = () => {
        setTaskChangeMessageDialogOpen(true);
        setTaskChangeMode("addSurveyTask");
        setTaskChangeMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.TASK_CHANGE_ADD_SURVEY_CONFIRM);
    };

    //「通常調査に戻す」ボタン押下時
    const handleChangeTaskNormal = () => {
        setTaskChangeMessageDialogOpen(true);
        setTaskChangeMode("normalTask");
        setTaskChangeMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.TASK_CHANGE_NORMAL_CONFIRM);
    };

    // タスク変更モーダルキャンセル処理
    const handelChangeTaskCancel = () => {
        setTaskChangeMessageDialogOpen(false);
        setTaskChangeMode("");
    };

    //タスク変更処理実行
    const taskChangeOnExecution = () => {
        setTaskChangeMessageDialogOpen(false);
        const param = {
            mode: "regist",
            endPoint: "/location/AddSurvey/v1/task-change",
            query: {
                plan_area_id: objLocationBase.plan_area_id, 
                branch: objLocationBase.branch,
                mode: taskChangeMode
            }
        };
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        (async () => {
            try {
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.TASK_CHANGE_NOW);
                setMessageDialogOpen(true);
                await apiRequest(param);
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.COMPLETE_TASK_CHANGE);
                setHasButton(true);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            } catch (e) {
                console.log(e);
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.UNCOMPLETE_TASK_CHANGE);
                setHasButton(true);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            }
        })();
    };


    return (
        <Box sx={{ width: "100%", margin: "30px" }}>
            {/* 追加調査ボタン */}
            {!objLocationBase.plan_area_id.startsWith("X") && 
            !objLocationBase.plan_area_id.startsWith("Y") && (
                <>
                    {taskChangeButtonType === "F" ? (
                        <Box>
                            <Button
                                sx={{ margin: "20px 0", fontSize: "19px" }}
                                variant="contained"
                                color="success"
                                size="small"
                                onClick={(e) => { handleChangeTaskNormal() }}
                                disabled = {
                                    userType !== LOCAL_CONSTANT.USER_TYPE.RFC
                                }
                            >
                                通常調査に戻す
                            </Button>
                        </Box>
                    ):(
                        <Box>
                            <Button
                                sx={{ margin: "20px 0", fontSize: "19px" }}
                                variant="contained"
                                color="success"
                                size="small"
                                onClick={(e) => { handleChangeTaskAddSurvey() }}
                                disabled = { 
                                    userType !== LOCAL_CONSTANT.USER_TYPE.RFC ? true
                                    : addSurveyTaskButton
                                }
                            >
                                追加調査を行う
                            </Button>
                        </Box>
                    )}
                </>
            )}
            {/* 結合ファイル表示 */}
            {userType == LOCAL_CONSTANT.USER_TYPE.RR && (            
                <Box>
                    <Button
                        sx={{ margin: "20px 0" }}
                        variant="contained"
                        color="success"
                        size="small"
                        onClick={(e) => { handleCreateMergeFile() }}
                        disabled={
                            objLocationAddSurvey.cover_pdf_path === "" && objLocationAddSurvey.cover_confirm_pdf_path === "" ? true :
                            setPermissionFunc(userType, objLocationBase.task_id, LOCAL_CONSTANT.NAVI.ADDITIONAL_RESEARCH, "mergePdfButton")
                        }
                    >
                        結合ファイルを作成する
                    </Button>
                </Box>
            )}
            <Grid container spacing={1}>
                <Grid item xs={12} sx={{ paddingRight: "40px" }}>
                    <TableContainer sx={{ width: "100%", border: "1px solid black" }}>
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={headerCell("FILE_NAME")}>{LOCAL_CONSTANT.LABEL.FILE_NAME}</TableCell>
                                    <TableCell sx={headerCell("UPLOAD_DATE")}>{LOCAL_CONSTANT.LABEL.UPLOAD_DATE}</TableCell>
                                    <TableCell sx={headerCell("UPLOADER")}>{LOCAL_CONSTANT.LABEL.UPLOADER}</TableCell>
                                    <TableCell sx={headerCell("OTHER")}></TableCell>
                                    <TableCell sx={headerCell("OTHER")}></TableCell>
                                    <TableCell sx={headerCell("OTHER")}>PDF</TableCell>
                                    <TableCell sx={headerCell("OTHER")}></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {mergePdfPath.map((val, index) => {
                                    // 最新ファイルは通常表示、それ以外はグレーアウト
                                    const isLatest = index === 0;
                                    const displayLabel = val.file_name.replace(".pdf", "");
                                    return (
                                        <TableRow 
                                            className="tableRow" 
                                            key={index}
                                            sx={{ backgroundColor: isLatest ? "#fff" : "#D9D9D9" }}
                                        >
                                            <TableCell onClick={() => handlePreviewChange(val.pdf_path)}>{displayLabel}</TableCell>
                                            <TableCell onClick={() => handlePreviewChange(val.pdf_path)}>{showUploadDate(val.upload_date)}</TableCell>
                                            <TableCell onClick={() => handlePreviewChange(val.pdf_path)}>{staffName(val.upload_user_id)}</TableCell>
                                            <TableCell sx={{ textAlign: "center" }}>
                                                {val.pdf_path !== "" && (
                                                    <IconButton
                                                        sx={{ color: "black" }} 
                                                        onClick={() =>
                                                            handlePdfPreviewModalOpen(
                                                                `${objLocationBase.plan_area_id}/${objLocationBase.branch}${val.pdf_path}`
                                                            )
                                                        }
                                                    >
                                                        <PictureAsPdfIcon />
                                                    </IconButton>
                                                )}
                                            </TableCell>
                                            <TableCell sx={{ textAlign: "center" }}>
                                                {val.pdf_path !== "" && (
                                                    <IconButton
                                                        sx={{ color: "black" }} 
                                                        onClick={() =>
                                                            handlePdfPreviewScreenOpen(
                                                                `${objLocationBase.plan_area_id}/${objLocationBase.branch}${val.pdf_path}`
                                                            )
                                                        }
                                                    >
                                                        <OpenInNewIcon />
                                                    </IconButton>
                                                )}
                                            </TableCell>
                                            <TableCell  sx={{ textAlign: "center" }}>
                                                {val.pdf_path !== "" && (
                                                    <IconButton 
                                                        sx={{ color: "black" }} 
                                                        onClick={() => commonFileDownload(`${objLocationBase.plan_area_id}/${objLocationBase.branch}${val.pdf_path}`, displayLabel)}
                                                        ><DownloadIcon />
                                                    </IconButton>
                                                )}
                                            </TableCell>
                                            <TableCell  sx={{ textAlign: "center" }}>
                                                {val.pdf_path !== "" && (
                                                    <IconButton 
                                                        sx={{ color: "black" }} 
                                                        onClick={() => handleDeleteConfModalOpen(val)}
                                                        disabled={setPermissionFunc(userType, objLocationBase.task_id, LOCAL_CONSTANT.NAVI.ADDITIONAL_RESEARCH, "mergeDeleteButton")}
                                                        ><DeleteIcon />
                                                    </IconButton>
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>

            {/* PDFプレビュー */}
            {previewPdfPath !== "" && (
                <Box sx={{ padding: "30px 40px 0px 0px" }}>
                    <PdfViewer props={{ pdfPath: previewPdfPath }} />
                </Box>
            )}

            {/* アコーディオン表示箇所 */}
            <Box sx={{ margin: "20px 40px 0px 0px" }}>
                <Accordion 
                    expanded={accordionDefaultFlag}
                    onChange={(_, isExpanded) => setAccordionDefaultFlag(isExpanded)}
                >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        追加調査・表紙添付資料
                    </AccordionSummary>
                    <AccordionDetails>
                        <AddCover
                            props={{
                                menuLabel: LOCAL_CONSTANT.LABEL.COVER_REFERENCE,
                                correctionLabel: "承認済み参考値を修正する",
                                addButton: "add_survey_cover_reference",
                                comenntButton: "add_survey_cover_reference_fixes",
                            }}
                        />
                        <AddCover
                            props={{
                                menuLabel: LOCAL_CONSTANT.LABEL.COVER_CONFIRMED,
                                correctionLabel: "承認済み確定値を修正する",
                                addButton: "add_survey_cover_confirmed",
                                comenntButton: "add_survey_cover_confirmed_fixes",
                            }}
                        />
                        <AddDescriptionDocument props={{}} />
                    </AccordionDetails>
                </Accordion>
            </Box>

            {/* メッセージ用モーダル */}
            <MessageDialog props={{
                open: messageDialogOpen,
                handleModal: closeMessageDialog,
                body: message,
                hasButton: hasButton,
                buttonBody: LOCAL_CONSTANT.LABEL.CLOSE,
            }}/>

            {/* PDFプレビューモーダル */}
            <PdfViewerModal
                props={{
                    open: pdfPreviewModalFlag,
                    setOpen: setPdfPreviewModalFlag,
                    pdfPath: pdfPath,
                }}
            />

            {/* PDF削除確認モーダル */}
            <DeleteConfirmationModal 
                modalOpen={deleteConfModalOpen} 
                setModalOpen={setDeleteConfModalOpen} 
                deleteMethod={handleDeleteChange} 
            />

            {/* タスク変更用確認モーダル */}
            <CriticalActionConfirmDialog props={{
                open: taskChangeMessageDialogOpen,
                onCancel: handelChangeTaskCancel,
                onExecution: taskChangeOnExecution,
                body: taskChangeMessage,
                confirmCancel: LOCAL_CONSTANT.LABEL.CANCEL,
                confirmOk: LOCAL_CONSTANT.LABEL.CHANGE,
            }}/>

        </Box>
    );
};

export default AdditionalResearch;
